<div class="d-flex f-row j-between a-center public-deal-container">
    <div *ngIf="quotationInfo" class="quotation-public-deal-container">
        <p class="color-heading">{{quotationInfo.way === 2 ? ('public_dials_you_send' | translate) :( 'public_dials_we_send' | translate)}}</p>
        <p class="d-flex color-heading f-row a-center number-quotation">{{quotationInfo.realQuotation}} {{quotationInfo.pair}}</p>
        <p>{{ 'insted_of' | translate }} {{quotationInfo.quotation}} {{quotationInfo.pair}}</p>
    </div>
    <app-gain-percent [percent]="publicDeal.attributes.gain_percent"></app-gain-percent>
</div>
